import { Add } from '@mui/icons-material'
import { Box, IconButton, Stack } from '@mui/material'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTexts } from './hooks/useTexts'
import { form } from './formState'
import { Tooltip } from '@/components/primitives/Tooltip'
import { selectMaxReasonsForNotCompletedOrders } from '@/features/domain/territory'
import { ReasonsForNotCompletedOrdersCount } from '../ReasonsForNotCompletedOrdersCount'
import { ReasonsForNotCompletedOrdersMenu } from './ReasonsForNotCompletedOrdersMenu'

export function ReasonsForNotCompletedOrdersFormHeader() {
  const texts = useTexts()
  const maxAllowedReasons = useSelector(selectMaxReasonsForNotCompletedOrders)

  const {
    field: { value },
  } = form.useFormField('reasonsForNotCompletedOrders')

  const fieldApi = form.useFormFieldApi('reasonsForNotCompletedOrders')

  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  const addIsBlocked = formDisabled || value.length === maxAllowedReasons

  const handleAddClick = useCallback(() => {
    if (addIsBlocked) return

    const newValue = [...value, '']
    fieldApi.change(newValue)
  }, [addIsBlocked, value, fieldApi])

  const addTooltipTitle = addIsBlocked ? texts.maxReasonsReached(maxAllowedReasons) : texts.add

  return (
    <Stack direction="row">
      <ReasonsForNotCompletedOrdersCount />
      <Box display="flex">
        <Tooltip title={addTooltipTitle} placement="top">
          <IconButton
            onClick={handleAddClick}
            disabled={addIsBlocked}
            data-testid="reason-for-orders_add-reason"
          >
            <Add />
          </IconButton>
        </Tooltip>
        <ReasonsForNotCompletedOrdersMenu />
      </Box>
    </Stack>
  )
}
